var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitLogout = function SvgExitLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#ExitLogout_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 1.4,
    d: "M12 4.778v14.443a1.78 1.78 0 0 1-2.164 1.736l-4.444-.988A1.78 1.78 0 0 1 4 18.234V5.766a1.78 1.78 0 0 1 1.393-1.735l4.444-.988A1.777 1.777 0 0 1 12 4.778"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M9 13.02v-2M20 8V5.958a2 2 0 0 0-2-2h-3M20 16v2a2 2 0 0 1-2 2h-3M15 12h5M18 14l2-2-2-2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ExitLogout_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgExitLogout;